import axios from "axios";

export function isSignedIn() {
    return (localStorage.getItem("token") !== null)
}

export function handleError(error: any, quiet: boolean = false) {
    console.warn(error);

    try {
        if (error.response !== undefined) {
            const err = error.response.data.data.reason;
            if (err !== "Invalid Token" && err !== "Invalid Session") {
                alert(err);
            } else {
                console.log("Invalid Token");
            }
        } else {
            if (!quiet) {
                alert(error.code);
            }
        }
    } catch (e) {
        if (!quiet) {
            alert(error.code);
        }
        console.warn(e);
    }
}

export function signOut() {
    localStorage.removeItem("token");
    localStorage.removeItem("token-expiry");
    localStorage.removeItem("userData");
    localStorage.removeItem("options");

    setTimeout(() => {
        window.location.reload();
    }, 500)

    //window.dispatchEvent(new Event("sso-state"));
}

export const ssoURL = "https://account.samaggisamagom.com/authenticate?req=1032a2ec-21bd-4acf-89df-3f32b69bfd66";

export async function checkToken() {
    return new Promise((resolve, ) => {
        if (!isSignedIn()) {
            resolve(false);
            return
        }

        const token = localStorage.getItem("token");

        if (token === null) {
            resolve(false);
            return
        }

        axios.post("https://k3rkw7qg78.execute-api.eu-west-2.amazonaws.com/Prod/api/check-token", {"token": token}).then(res => {
            console.log(res);
            try {
                if (res.data.data.valid === true) {
                    localStorage.setItem("token-expiry", res.data.data.expiry);
                    resolve(true)
                }
                resolve(false)
            } catch (e) {
                console.warn(e);
                resolve(false)
            }
        }).catch((error) => {
            console.warn(error)
            try {
                if (error.response !== undefined) {
                    alert(error.response.data.data.reason);
                } else {
                    //alert(error.message);
                }
            } catch (e) {
                //alert(error.message);
                console.warn(e);
            }
            resolve(false);
        })
    })
}